var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { getSafeGutter, validateGutter } from "@bedrock-layout/spacing-constants";
import { Stack } from "@bedrock-layout/stack";
import { forwardRefWithAs } from "@bedrock-layout/type-utils";
import useContainerQuery from "@bedrock-layout/use-container-query";
import useForwardedRef from "@bedrock-layout/use-forwarded-ref";
import * as React from "react";
import styled from "styled-components";
var propTypes = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
const fractions = {
  "1/4": "1fr 3fr",
  "1/3": "1fr 2fr",
  "1/2": "1fr 1fr",
  "2/3": "2fr 1fr",
  "3/4": "3fr 1fr",
  "auto-start": `auto 1fr`,
  "auto-end": `1fr auto`
};
const SplitBase = styled.div.attrs(({ fraction, theme, gutter, style }) => {
  const attrString = fraction && fractions[fraction] ? `fraction:${fraction}` : "";
  const maybeGutter = getSafeGutter(theme, gutter);
  return {
    "data-bedrock-split": attrString,
    style: __spreadProps(__spreadValues({}, style), { "--gutter": maybeGutter }),
    gutter: void 0
  };
})`
  box-sizing: border-box;
  > * {
    margin: 0;
  }

  display: grid;
  gap: var(--gutter, 0px);
  grid-template-columns: ${({ fraction = "1/2" }) => {
  var _a;
  return (_a = fractions[fraction]) != null ? _a : fractions["1/2"];
}}};
`;
const Splitter = forwardRefWithAs((_a, ref) => {
  var _b = _a, { fraction, switchAt, as } = _b, props = __objRest(_b, ["fraction", "switchAt", "as"]);
  const safeRef = useForwardedRef(ref);
  const node = safeRef.current;
  const maybePx = React.useMemo(() => {
    return typeof switchAt === "string" ? toPX(switchAt, node) : typeof switchAt === "number" && switchAt > -1 ? switchAt : null;
  }, [switchAt, node]);
  const widthToSwitchAt = maybePx ? maybePx : 0;
  const shouldSwitch = useContainerQuery(node, widthToSwitchAt);
  return shouldSwitch ? /* @__PURE__ */ React.createElement(Stack, __spreadValues({
    as,
    ref: safeRef
  }, props)) : /* @__PURE__ */ React.createElement(SplitBase, __spreadValues({
    as,
    ref: safeRef,
    fraction
  }, props));
});
const Split = styled(Splitter).attrs(({ as, forwardedAs }) => {
  return {
    forwardedAs: as != null ? as : forwardedAs,
    as: Splitter
  };
})``;
Split.displayName = "Split";
Split.propTypes = {
  gutter: validateGutter,
  fraction: PropTypes.oneOf(Object.keys(fractions)),
  switchAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
const PIXELS_PER_INCH = 96;
function parseUnit(str) {
  var _a;
  str = String(str);
  const num = parseFloat(str);
  const [, unit] = (_a = str.match(/[\d.\-+]*\s*(.*)/)) != null ? _a : ["", ""];
  return [num, unit];
}
function toPX(str, element) {
  if (!str)
    return null;
  const elementOrBody = element != null ? element : document.body;
  const safeStr = (str != null ? str : "px").trim().toLowerCase();
  switch (safeStr) {
    case "vmin":
    case "vmax":
    case "vh":
    case "vw":
    case "%":
      return null;
    case "ch":
    case "ex":
      return getSizeBrutal(safeStr, elementOrBody);
    case "em":
      return getPropertyInPX(elementOrBody, "font-size");
    case "rem":
      return getPropertyInPX(document.body, "font-size");
    case "in":
      return PIXELS_PER_INCH;
    case "cm":
      return PIXELS_PER_INCH / 2.54;
    case "mm":
      return PIXELS_PER_INCH / 25.4;
    case "pt":
      return PIXELS_PER_INCH / 72;
    case "pc":
      return PIXELS_PER_INCH / 6;
    case "px":
      return 1;
    default: {
      const [value, units] = parseUnit(safeStr);
      if (isNaN(value))
        return null;
      if (!units)
        return value;
      const px = toPX(units, element);
      return typeof px === "number" ? value * px : null;
    }
  }
}
function getPropertyInPX(element, prop) {
  var _a;
  const [value, units] = parseUnit(getComputedStyle(element).getPropertyValue(prop));
  return value * ((_a = toPX(units, element)) != null ? _a : 1);
}
function getSizeBrutal(unit, element) {
  const testDIV = document.createElement("div");
  testDIV.style["height"] = "128" + unit;
  element.appendChild(testDIV);
  const size = getPropertyInPX(testDIV, "height") / 128;
  element.removeChild(testDIV);
  return size;
}
export { Split };
